import './resources.css'

const SecondWebinarResource = () => {
    return (
        <ul className= 'additional-resources' >
            <h3> Additional Resources: </h3>
            <li onClick = {() => window.open("https://www.securepork.org/Resources/SPS_CreatingPremisesMap-AnimalsRaisedIndoors.pdf")}> Creating a Premises Map for a Biosecurity Plan (SPS)  </li>
            <li onClick={() => window.open("https://www.cfsph.iastate.edu/Assets/step1-movement-risks-biosecurity.pdf")}> Movement risks and biosecurity: Checklist (CFSPH) </li>
            <li onClick={() => window.open("https://www.cfsph.iastate.edu/Assets/tip-sheet-animal-movement.pdf")}> Animal Movement Tip Sheet (CFSPH) </li>
            {/*Nested List */}
            <li onClick={()=> window.open("https://www.cfsph.iastate.edu/Assets/tip-sheet-vehicles-equipment.pdf")}> Vehicles and Equipment Tip Sheet </li>
        </ul>
    )
}

export default SecondWebinarResource;